import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AppPaths from '../AppPaths';
import { isInAppShop } from '../lib/inAppShop';
import { cartActions as storeCartActions } from '../reducers/storeCart';
import { useHardwareFirstStoreCartAtCap } from './useHardwareFirstCartUnits';

/**
 * PDP add-to-bag guard for the hardware-first arm. `atCap` means the persisted cart already holds
 * the maximum hardware units, so the add must be skipped (the server rejects a sixth unit) and the
 * bag's bulk-sales notice explains. `routeToBag` navigates to the bag, honoring the in-app shop's
 * modal checkout. A single owner for the cap check keeps analytics and cart dispatches in
 * agreement across MiniPDP, UltraPDP, and the series 3 store PDP.
 */
export default function useHardwareFirstAddGuard(): { atCap: boolean; routeToBag: () => void } {
  const atCap = useHardwareFirstStoreCartAtCap();
  const dispatch = useDispatch();
  const history = useHistory();

  const routeToBag = useCallback(() => {
    if (isInAppShop()) {
      dispatch(storeCartActions.setShowInAppCheckout(true));
    } else {
      history.push(AppPaths.Bag);
    }
  }, [dispatch, history]);

  return { atCap, routeToBag };
}
